// THIS FILE MUST NOT IMPORT FROM ANY OTHER SOURCE FILE
// This lets us import globals from anywhere without introducing import cycles

/** height of app-wide top nav (SeachNav component) */
export const TOP_NAV_HEIGHT = 60;

export const MAX_HISTORIES_LOADED = 10;
export const MAX_STORAGE_TREE_NODES = 500;
export const MAX_NUM_FILES = 10000;

export const CHART_SAMPLES = 1500;
// We must maintain CHART_SAMPLES / CHART_MAX_X_BUCKETS === 6
// to ensure each bucket has enough points to get a representative sample.
// Note: 6 is arbitrary, we may want more.
export const CHART_MAX_X_BUCKETS = 250;

export const NULL_STRING = 'null';
export const NULL_STRING_ANGLE_BRACKETS = '<null>';

export const TABLE_MAX_COLUMN_HEADER_LENGTH = 12; // unit = number of characters.  column names longer than this will display using truncateString
export const TABLE_DEFAULT_NAME_COLUMN_WIDTH = 280; // default px width for the "Name" column in the table
export const TABLE_DEFAULT_COLUMN_WIDTH = 120; // default px width for all other columns in the table
export const TABLE_MIN_COLUMN_WIDTH = 70; // minimum px width for columns in the table

export const PUBLISHED_PROJECT_NAME = '--internal-published-project';

export const NOOP = () => {};
export const RETURN_NULL = () => null;

export const EMPTY_ARRAY: readonly any[] = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});

export const RESERVED_KEYS = ['_wandb'];
export const EMPTY_ARTIFACT_NAME = '__empty__';

export const MAX_PINNED_RUNS = 20;
export const OLD_MAX_PINNED_RUNS = 6; // legacy; will be removed once cross project runs is GA

export const MAX_REPORT_DISPLAY_NAME_LENGTH = 128;

export const MAX_API_KEYS_PER_SCOPE = 100;

// Regex for detecting git diff files in the Run Overview pages
//
// diff.patch and diff_{sha}.patch are diffs generated by the SDK when there
// are unstaged or unpushed changes in the git repo when the run was
// started. We want to detect these files in a few different places, so
// constants make sense here.
export const DIFF_FILE_REGEX_WITH_OPTIONAL_SHA =
  /^diff(_[0-9a-f]{5,40})?\.patch$/;
export const DIFF_FILE_REGEX_WITH_SHA = /^diff_[0-9a-f]{5,40}\.patch$/;
